/**
 * "Anbefalet til dig" on the EMPTY cart page — live Relewise recommendations
 * replacing the server-rendered baseline (settings.empty_cart_products).
 * Loaded by sections/cart.liquid only when the Relewise theme setting is on.
 *
 * PopularProducts, not the cart drawer's PurchasedWithMultipleProducts: that
 * request is seeded from cart lines and this block only ever renders when the
 * cart is empty, so there is nothing to seed it with. Popular over the last 14
 * days is the documented slot for an empty context
 * (docs/relewise-implementation.md §7, same pattern as relewise-404.js).
 *
 * The block must ALWAYS show products, so failure is never fatal: any error,
 * empty result, or unresolvable handle simply leaves the curated server-rendered
 * cards in place. It only replaces them once it holds real cards.
 */
!(function () {
  'use strict';

  var grid = document.querySelector('[data-cart-empty-recs]');
  if (!grid) return;

  /* The grid loads behind the shared skeleton ([data-relewise-hold], see
     spejder.css "Recommendation rows"); every exit path releases it — onto the
     real cards, or back onto the curated baseline. */
  function settle() { grid.setAttribute('data-relewise-ready', ''); }

  var cfg = window.spejder && window.spejder.relewise;
  if (!cfg || !cfg.enabled || !window.Relewise) { settle(); return; }

  var limit = parseInt(grid.getAttribute('data-limit')) || 4;
  var handleKey = cfg.shop + '_ShopifyHandle';

  /* Consent-correct identity via the shared helper (assets/relewise-batch.js),
     which waits for the app embed's global instead of testing for it now. */
  var userPromise = window.spejder.relewiseUser
    ? window.spejder.relewiseUser()
    : Promise.resolve(Relewise.UserFactory.anonymous());

  userPromise
    .then(function (user) {
      var request = new Relewise.PopularProductsBuilder({
        language: cfg.language,
        currency: cfg.currency,
        displayedAtLocation: 'Cart Page',
        user: user,
      })
        /* sinceMinutesAgo is REQUIRED — PopularProducts returns nothing without
           it (docs §7). 20160 = 14 days, same window as the 404 row. */
        .sinceMinutesAgo(20160)
        .setNumberOfRecommendations(limit)
        .setSelectedProductProperties({ dataKeys: [handleKey] })
        .build();
      /* One request with the cart page's other rows ("Senest set", the drawer's
         basket recommendations) — see assets/relewise-batch.js. */
      if (window.spejder.relewiseBatch) return window.spejder.relewiseBatch.recommend(request);
      var recommender = new Relewise.Recommender(cfg.datasetId, cfg.apiKey, { serverUrl: cfg.serverUrl });
      return recommender.recommendPopularProducts(request);
    })
    .then(function (result) {
      var handles = ((result && result.recommendations) || []).map(function (rec) {
        return rec.data && rec.data[handleKey] && rec.data[handleKey].value;
      }).filter(Boolean);
      if (!handles.length) return settle();

      return Promise.all(handles.slice(0, limit).map(function (h) {
        return fetch('/products/' + h + '?view=relewise-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (cards) {
        /* A handle Relewise knows but Shopify does not still answers 200 with an
           EMPTY card shell (no <img>, no product link) — status alone cannot
           tell them apart, so filter on the product link the shell lacks.
           Same trap as the blank card in "Senest set". */
        cards = cards.filter(function (html) {
          return html && html.indexOf('href="/products/') !== -1;
        });
        if (!cards.length) return settle();
        grid.innerHTML = cards.join('');
        settle();
        grid.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
      });
    })
    .catch(function () { settle(); /* keep the curated baseline */ });
})();
